import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contacto" className="py-32 bg-bodyon-surface relative overflow-hidden" data-id="element-59">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center" data-id="element-61">
          {/* Left: Massive Vertical Heading */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col" data-id="element-62">
            <h2 className="font-heading font-black text-[10vw] lg:text-[7vw] leading-[0.85] tracking-tighter text-bodyon-teal-dark uppercase" data-id="element-63">
              <span className="block hover:text-bodyon-teal transition-colors duration-500" data-id="element-64">
                {t('contact.line1')}
              </span>
              <span className="block hover:text-bodyon-teal transition-colors duration-500" data-id="element-65">
                {t('contact.line2')}
              </span>
              <span className="block text-bodyon-teal" data-id="element-66">
                {t('contact.line3')}
              </span>
            </h2>

            <div className="mt-16 flex flex-col sm:flex-row gap-12 text-lg text-gray-600 font-light" data-id="element-67">
              <div data-id="element-68">
                <span className="block text-sm font-bold text-bodyon-teal-dark uppercase tracking-widest mb-2" data-id="element-69">
                  {t('contact.callUs')}
                </span>
                +52 (56) 2320 5056
              </div>
              <div data-id="element-70">
                <span className="block text-sm font-bold text-bodyon-teal-dark uppercase tracking-widest mb-2" data-id="element-71">
                  {t('contact.writeUs')}
                </span>
                contacto@bodyon.com.mx
              </div>
            </div>
          </motion.div>

          {/* Right: Minimal Form */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-10 md:p-16 rounded-[40px] shadow-xl" data-id="element-72">
            <form className="space-y-10" onSubmit={e => e.preventDefault()} data-id="element-73">
              <div className="relative group" data-id="element-74">
                <input type="text" placeholder={t('contact.name')} className="w-full bg-transparent border-b-2 border-gray-200 py-4 text-xl text-bodyon-teal-dark placeholder-gray-400 focus:outline-none focus:border-bodyon-teal transition-colors peer" data-id="element-75" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-76">
                <div className="relative group" data-id="element-77">
                  <input type="tel" placeholder={t('contact.phone')} className="w-full bg-transparent border-b-2 border-gray-200 py-4 text-xl text-bodyon-teal-dark placeholder-gray-400 focus:outline-none focus:border-bodyon-teal transition-colors" data-id="element-78" />
                </div>
                <div className="relative group" data-id="element-79">
                  <input type="email" placeholder={t('contact.email')} className="w-full bg-transparent border-b-2 border-gray-200 py-4 text-xl text-bodyon-teal-dark placeholder-gray-400 focus:outline-none focus:border-bodyon-teal transition-colors" data-id="element-80" />
                </div>
              </div>

              <div className="relative group" data-id="element-81">
                <textarea rows={3} placeholder={t('contact.message')} className="w-full bg-transparent border-b-2 border-gray-200 py-4 text-xl text-bodyon-teal-dark placeholder-gray-400 focus:outline-none focus:border-bodyon-teal transition-colors resize-none" data-id="element-82"></textarea>
              </div>

              <button className="w-full bg-bodyon-teal-dark hover:bg-bodyon-teal text-white font-bold text-xl py-6 rounded-full transition-all duration-500 shadow-lg hover:shadow-xl hover:-translate-y-1 mt-8" data-id="element-83">
                {t('contact.send')}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}